function ReloadIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M1.85 7.5A5.62 5.62 0 0 1 7.5 1.85c2.78 0 4.15 2.06 4.74 3.15H10.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.81C12.3 3.07 10.67.85 7.5.85 3.44.85.85 4.18.85 7.5s2.59 6.65 6.65 6.65a6.5 6.5 0 0 0 4.71-1.94 6.8 6.8 0 0 0 1.43-2.17.5.5 0 1 0-.92-.38 5.8 5.8 0 0 1-1.22 1.85 5.5 5.5 0 0 1-4 1.64A5.62 5.62 0 0 1 1.85 7.5"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
export default ReloadIcon;
